import { get, post, put, del, patch } from '@elementary/common-ui/utils/http';
import {
  SsoConfig,
  CreateSsoRequest,
  EnableSsoRequest,
  UpdateSsoRequest,
} from './types';

const API_BASE = import.meta.env.VITE_API_BASE_URL;

export const fetchSsoConfig = (): Promise<SsoConfig> =>
  get(`${API_BASE}/account/sso/config`);

export const createSsoConfig = (data: CreateSsoRequest): Promise<SsoConfig> =>
  post(`${API_BASE}/account/sso/config`, {
    metadata_xml: data.metadataXml,
    domain_names: data.domainNames,
  });

export const enableSsoConfig = (data: EnableSsoRequest): Promise<SsoConfig> =>
  put(`${API_BASE}/account/sso/config/enable`, data);

export const clearSsoConfig = (): Promise<void> =>
  del(`${API_BASE}/account/sso/config`);

export const updateSsoConfig = (data: UpdateSsoRequest): Promise<SsoConfig> =>
  patch(`${API_BASE}/account/sso/config`, {
    metadata_xml: data.metadataXml,
    domain_names: data.domainNames,
  });
